/**
 * 运行时配置工具
 * 从 window.__APP_CONFIG__ 读取配置，支持部署时独立更新 config.js
 *
 * 归一化规则：
 * - API_BASE_URL：自动去除尾部 /（模板字符串拼接处已带前导 /）
 * - WEBSOCKET_URL：自动补齐尾部 /（模板字符串拼接处未带前导 /）
 * 因此 public/config.js 中配置有无末尾 / 均可正常工作。
 */
const appConfig = window.__APP_CONFIG__ || {}

function normalizeBaseUrl(url) {
  if (!url) return ''
  return url.replace(/\/+$/, '')
}
function normalizeWsUrl(url) {
  if (!url) return ''
  return url.endsWith('/') ? url : url + '/'
}

export const API_BASE_URL = process.env.NODE_ENV === 'development'
  ? '/api'
  : normalizeBaseUrl(appConfig.API_BASE_URL)
export const WEBSOCKET_URL = normalizeWsUrl(appConfig.WEBSOCKET_URL)
